/**
 * @author: Angel Labrada Massó
 * @version: v0.0.1
 * @date:
 */
import React, { memo } from 'react';

const GridBanner = () => {
  return (
    <svg width='27' height='15' viewBox='0 0 27 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='3.66211' width='7.84416' height='7.32121' rx='1.54361' fill='white' />
      <rect x='8.89062' y='3.66211' width='8.3671' height='7.32121' rx='1.54361' fill='white' />
      <rect x='18.3047' y='3.66211' width='7.84416' height='7.32121' rx='1.54361' fill='white' />
    </svg>
  );
};

export default memo(GridBanner);
